import React, { Component } from 'react';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { SelectCampaign } from '../../../../../../common/components/index';
import './SelectCampaigns.scss';

class SelectCampaigns extends Component {
  render() {
    return (
      <div className="container-select">
        <div className="select-field-dropdown">
          <Field
            name="data.attributes.metadata.campaign"
            component={SelectCampaign}
            isClearable
            noCache
            label="Voucher Code"
            labelSize={4}
            {...this.props}
          />
        </div>
      </div>
    );
  }
}

const FORM_NAME = 'LeisureTravelForm';

const form = reduxForm({ form: FORM_NAME })(SelectCampaigns);
const selector = formValueSelector(FORM_NAME);
const mapStateToProps = (state, props) => {
  const values = selector(state, 'data');

  return {
    auth: state.auth,
    initialValues: props.resource,
    form: 'LeisureTravelForm',
    formValues: values,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    product: state.product,
  };
};

export default connect(mapStateToProps)(form);
